(() => {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-merlons-contact-video][data-video-id]');
    if (!button) return;
    const id = button.dataset.videoId;
    if (!id) return;
    const title = button.dataset.videoTitle || 'Merlons branch video';
    const iframe = document.createElement('iframe');
    iframe.title = title;
    iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?rel=0&modestbranding=1&playsinline=1&autoplay=1`;
    iframe.loading = 'eager';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allowFullscreen = true;
    iframe.className = 'merlons-contact__video-player';
    iframe.tabIndex = 0;
    button.replaceWith(iframe);
    window.setTimeout(() => iframe.focus(), 0);
  });
})();
